import CareerRepository from "../api/career";

class CareerUseCase {
  constructor() {
    /** @type {CareerRepository} */ 
    this.api = new CareerRepository()
  }

  async getAll(param) {
    const {data, err} = await this.api.getAll(param)
    if (err && err === "record not found") {
      return {data: null, err: null}
    }

    return {data, err}
  }

  async getDetail(id) {
    const {data, err} = await this.api.getDetail(id)
    return {data, err}
  }

  async create(payload) {
    const {data, err} = await this.api.create(payload)
    return {data, err}
  }

  async edit(id, payload) {
    const {data, err} = await this.api.edit(id, payload)
    return {data, err}
  }
}

export default new CareerUseCase()
